module.exports = __webpack_public_path__ + "img/知识攻略@2x.4fcd1be5.jpg";